import React from "react";
import "./Overlay.css";

const Overlay = ({ children }) => <div className="overlay">{children}</div>;

export default Overlay;
